import { render, staticRenderFns } from "./input-radio-boolean.vue?vue&type=template&id=6d9792b2"
import script from "./input-radio-boolean.vue?vue&type=script&lang=js"
export * from "./input-radio-boolean.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports